import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, Divider, CircularProgress } from '@material-ui/core';
import useTable from '../../useTable';
import SearchIcon from '@material-ui/icons/Search';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../../CustomAlert';
import { Helmet } from 'react-helmet';
import { getPurchaseBillsDocumentWithUserId } from '../../../Backend/firebase/purchase-bills';
import PurchaseBillsFilter from './PurchaseBillsFilter';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
        width: '100%'
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'InvoiceDate', label: 'Invoice Date', disableSorting: false },
    { id: 'InvoiceNo', label: 'Invoice No', disableSorting: false },
    { id: 'ProductName', label: 'Product Name', disableSorting: true },
    { id: 'BatchNo', label: 'Batch No', disableSorting: false },
    { id: 'Quantity', label: 'Quantity', disableSorting: false },
    { id: 'GrossValue', label: 'Gross Value', disableSorting: false },
    { id: 'GSTValue', label: 'GST Value', disableSorting: false },
    { id: 'TotalAmount', label: 'Total Amount', disableSorting: false },
    { id: 'AmountPaid', label: 'Amount Paid', disableSorting: false },
    { id: 'PaymentMode', label: 'Payment Mode', disableSorting: false },
    { id: 'Party', label: 'Vendor Name', disableSorting: false },
    { id: 'SalesPerson', label: 'Sales Person', disableSorting: false },
]

function PurchaseBillsHistory() {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [searchChange, setSearchChange] = useState(false);
    const [pageAfterSearch, setPageAfterSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn,
        searchChange, pageAfterSearch);
    const history = useHistory();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [totalAmount, setTotalAmount] = useState('');
    const [amountPaid, setAmountPaid] = useState('');
    const [quantity, setQuantity] = useState('');
    const [alertType, setAlertType] = useState('');

    const handleSearch = (e) => {
        let target = e.target;
        if (target.value === '') {
            setSearchChange(false);
            setPageAfterSearch(false);
        }
        else {
            setSearchChange(true);
            setPageAfterSearch(true);
        }
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items
                } else {
                    return items.filter(x => x.Product.toLowerCase().includes(target.value.toLowerCase()));
                }
            }
        });
    };

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getPurchaseBills = await getPurchaseBillsDocumentWithUserId(userData.uid);
                setTotalAmount(getPurchaseBills.reduce((accumulator, object) => {
                    return Number(accumulator) + Number(object.TotalAmount)
                }, 0))
                setAmountPaid(getPurchaseBills.reduce((accumulator, object) => {
                    return Number(accumulator) + Number(object.PaymentReceived)
                }, 0))
                setQuantity(getPurchaseBills.map((item) => {
                    return item?.ProductEntry.reduce((accumulator, object) => {
                        return Number(accumulator) + Number(object?.ProductOrderQuantity)
                    }, 0)
                }))
                setRecords(getPurchaseBills);
                setIsLoading(false);
            } catch(error) {
                console.log("Error Occur in Get Purchase Bills", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const handleFilters = async (filter) => {
        console.log('Filter Changed => ', filter);
    };

    const refreshData = async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getPurchaseBills = await getPurchaseBillsDocumentWithUserId(userData.uid);
                setTotalAmount(getPurchaseBills.reduce((accumulator, object) => {
                    return Number(accumulator) + Number(object.TotalAmount)
                }, 0))
                setAmountPaid(getPurchaseBills.reduce((accumulator, object) => {
                    return Number(accumulator) + Number(object.PaymentReceived)
                }, 0))
                setQuantity(getPurchaseBills.map((item) => {
                    return item?.ProductEntry.reduce((accumulator, object) => {
                        return Number(accumulator) + Number(object?.ProductOrderQuantity)
                    }, 0)
                }))
                setRecords(getPurchaseBills);
                setIsLoading(false);
                setNotificationMessage('Purchase Record updated successfully.');
                setOpenNotify(true);
                setAlertType('success');
            } catch(error) {
                console.log("Error Occur in Get Purchase Bills", error)
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProductsAndPurchase">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Purchase Bills you have posted till now." />
                            <title>Purchase Bills | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-8">
                                <PurchaseBillsFilter handleFilters={handleFilters} refreshData={refreshData} />
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center w-100 align-items-center allProductsTable__searchBox">
                                    <SearchIcon className="mr-2" />
                                    <input type="text" placeholder="Search Purchase Bills..." className="border-0"
                                        onChange={handleSearch} />
                                </div>
                            </div>
                            {records.length > 0 ? <div className="row col-md-12">
                                <div className="card-events-body d-flex flex-column mt-3">
                                    <div className="card-events-details-popup">
                                        {<h6 className="card-events-title product__mainTitle">Total Quantity: <b>{quantity}</b></h6>}
                                        {<h6 className="card-events-title product__mainTitle">Total Amount paid: <b>{`Rs. ${amountPaid}`}</b></h6>}
                                        {<h6 className="card-events-title product__mainTitle">Total Sales Value: <b>{`Rs. ${totalAmount}`}</b></h6>}
                                    </div>
                                </div>
                                <TblContainer>
                                    <TblHead />
                                    <TableBody>
                                        {
                                            recordsAfterPagingAndSorting().map(item => (
                                                <TableRow key={item.id}>
                                                    <TableCell>{item.InvoiceDate}</TableCell>
                                                    <TableCell>{item.InvoiceNo ? item.InvoiceNo : "NA"}</TableCell>
                                                    <TableCell>{item?.ProductEntry ? item?.ProductEntry.length > 0 ? <>
                                                        {item?.ProductEntry.map((item)=> {
                                                            return (
                                                                <div className="historyBox">
                                                                    <p>{item.ProductName ? item.ProductName : "NA"}</p>
                                                                    <Divider className="border__history" />
                                                                </div>
                                                            )
                                                        })}
                                                    </> : 'NA' : 'NA'}</TableCell>
                                                    <TableCell>{item?.ProductEntry ? item?.ProductEntry.length > 0 ? <>
                                                        {item?.ProductEntry.map((item)=> {
                                                            return (
                                                                <div className="historyBox">
                                                                    <p>{item.BatchNo ? item.BatchNo : "NA"}</p>
                                                                    <Divider className="border__history" />
                                                                </div>
                                                            )
                                                        })}
                                                    </> : 'NA' : 'NA'}</TableCell>
                                                    <TableCell>{item?.ProductEntry ? item?.ProductEntry.length > 0 ? <>
                                                        {item?.ProductEntry.map((item)=> {
                                                            return (
                                                                <div className="historyBox">
                                                                    <p>{item.ProductOrderQuantity ? item.ProductOrderQuantity : "NA"}</p>
                                                                    <Divider className="border__history" />
                                                                </div>
                                                            )
                                                        })}
                                                    </> : 'NA' : 'NA'}</TableCell>
                                                    <TableCell>{item.GrossValue ? `Rs. ${item.GrossValue}` : "NA"}</TableCell>
                                                    <TableCell>{item.GSTValue ? `Rs. ${item.GSTValue}` : "NA"}</TableCell>
                                                    <TableCell>{item.TotalAmount ? `Rs. ${item.TotalAmount}` : "NA"}</TableCell>
                                                    <TableCell>{item.PaymentReceived ? `Rs. ${item.PaymentReceived}` : "NA"}</TableCell>
                                                    <TableCell>{item?.PaymentMode ? item.PaymentMode : "NA"}</TableCell>
                                                    <TableCell>{item?.PartyEntry && item?.PartyEntry.length > 0 ? item?.PartyEntry[0]?.PartyName : "NA"}</TableCell>
                                                    <TableCell>{item?.SalesPersonName ? item.SalesPersonName : "NA"}</TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </TblContainer>
                                <TblPagination />
                            </div> : <div className="row col-md-12 mt-3 text-center">
                                <img src={NotFound} className="notFound" />
                                <h4>No Purchase Bills Record Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                </div>)
            }
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default PurchaseBillsHistory
